import { useEffect, useState, useContext } from "react";
import { Button, Space, message } from "antd";
import useHttpClient from 'shared/hooks/http-hook';
import { AuthContext } from 'shared/context/auth-context';
import exportToExcel from 'shared/utils/exportToExcel';
import exportToCSV from 'shared/utils/exportToCSV';
import {getToday} from "shared/utils/dateUtils";
import Spinner from 'components/UIElements/Spiner/Spiner'
import './exportData.css'

export default function ExportData({ endPoint, columns, status, totalCount, exportFilename, ContractTab, title }) {
    const { responseData, sendRequest } = useHttpClient();
    const { roleUser } = useContext(AuthContext);
    const [eventButton, setEventButton] = useState('')
    const [disabled, setDisabled] = useState(roleUser === "GT" || "AnyTimeAdmin" ? false : !false);
    const [isBlocking, setIsBlocking] = useState(false)

    useEffect(() => {
        if (responseData) setDisabled(false);
    }, [responseData]);

    useEffect(() => {
        if (responseData?.items.length !== 0 && eventButton === 'excel') {
            exportToExcel(columns, responseData?.items, status, totalCount, ContractTab ? exportFilename.concat(`-${getToday().today}-${getToday().time}`) : exportFilename, title)
        }
        if (responseData?.items.length !== 0 && eventButton === 'csv') {
            exportToCSV(responseData?.items, columns, ContractTab ? exportFilename.concat(`-${getToday().today}-${getToday().time}`) : exportFilename, title)
        }
        if (responseData?.items.length === 0) { message.info("Δεν Υπάρχουν Δεδομένα για εξαγωγή", [5]) }
        setEventButton('')
        setIsBlocking(false)
    }, [responseData, columns, exportFilename])

    const fetchAllItemsForExport = (e) => {
        setEventButton(e)
        sendRequest({
            endpoint: endPoint?.concat(`&items=${1}&page=${1}&ispaginated=${false}`),
            method: 'GET',
        })
        setDisabled(true)
        setIsBlocking(true)
        message.info("Η διαδικασία εξαγωγής αρχείου έχει ξεκινήσει", [5])
    }

    return (
        <>
            {isBlocking ? (<div id='overlay' ><Spinner /></div>) : null}
            <Space style={{ marginBottom: 16 }}>
                <Button htmlType="submit" onClick={() => { fetchAllItemsForExport('excel'); }} disabled={disabled}>
                    excel
                </Button>
                <Button htmlType="submit" onClick={() => { fetchAllItemsForExport('csv'); }} disabled={disabled} >
                    csv
                </Button>
            </Space>
        </>
    )
}   